<template>
  <div>
    <template
      v-for="(item,index) in msgTypeList"
      :key="index"
    >
      <TextMessageView
        v-if="item.l2Type === msgL2Type.text"
        :key="'text' + index"
        :text="text"
        :text-node-config-list="textNodeConfigList"
      />
      <PicMessageView
        v-else-if="item.l2Type === msgL2Type.pic"
        :key="'text' + index"
        :pic-info="picInfo"
      />
      <div
        v-if="index!==msgTypeList.length-1"
        :key="'split' + index"
        class="margin-box"
      />
    </template>
  </div>
</template>


<script lang="ts" setup>
import TextMessageView from '@/component/message/text/index.vue';
import PicMessageView from '@/component/message/pic/index.vue';
import { TextNodeConfig } from '@/business/chat/generate-text-node-config';
import { PropType } from 'vue';
import { MixedMsgItem, MsgL2Type, PicInfo } from '_c/typings/proto';

defineProps({
  text: { type: String, required: true },
  msgTypeList: { type: Array as PropType<Array<MixedMsgItem>>, required: true },
  picInfo: { type: Array as PropType<Array<PicInfo>>, default: () => [{}], required: true },
  textNodeConfigList: { type: Array as PropType<Array<TextNodeConfig>>, required: true },
});

const msgL2Type = {
  text: MsgL2Type.MsgL2TypeText,
  pic: MsgL2Type.MsgL2TypePic,
};

</script>

<script lang="ts">
export default {
  name: 'MixedMessageView',
};
</script>
<style lang="scss" scoped>
.margin-box {
  height: 8px;
}
</style>
